import * as React from "react";
import Panel from "./Panel";
import { NavigationButton, NavigationButtonType } from "components/Button";
import FlatButton from "material-ui/FlatButton";

import styles = require("./empty.less");

interface OnboardingPageProps {
    title: string;
    intro?: string;
    panels: Array<{ description: React.ReactNode, imageSrc: string }>;
    navigationButton?: {
        label: string,
        path: string
    };
    customNavigation?: React.ReactNode;
    learnMore?: React.ReactNode;
}

const OnboardingPage = (props: OnboardingPageProps) => {
    return <div className={styles.onboardingContainer}>
        <div className={styles.title}>
            <h2>{props.title}</h2>
            {props.intro && <p>{props.intro}</p>}
        </div>
        <div className={styles.panels}>
            {props.panels.map(panel =>
                <Panel key={panel.imageSrc} description={panel.description} imageSrc={panel.imageSrc} />
            )}
        </div>
        <div className={styles.onboardingCreateFirst}>
            {props.customNavigation}
            {props.navigationButton && <NavigationButton type={NavigationButtonType.Primary} label={props.navigationButton.label} href={props.navigationButton.path} />}
            {props.learnMore}
        </div>
    </div>;
};

export default OnboardingPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/OnboardingPage.tsx